import { useGetMessagesQuery, useSendMessageMutation, useDeleteMessageMutation, useClearChatMutation } from '../features/chat/chatApiSlice';

export const useChatMessages = (chatId, options = {}) => {
  const result = useGetMessagesQuery(chatId, options);
  const [sendMessage, sendResult] = useSendMessageMutation();
  const [deleteMessage, deleteResult] = useDeleteMessageMutation();
  const [clearChat, clearResult] = useClearChatMutation();
  return {
    ...result,
    sendMessage,
    sendResult,
    deleteMessage,
    deleteResult,
    clearChat,
    clearResult,
  };
};

export default useChatMessages;
